<template>
    <div class="content">
        <div class="tabBig">
            <div class="tabBox">
                <div
                    class="tabLi"
                    :class="tabIndex == item.id ? 'tabLiA' : ''"
                    v-for="(item, index) in tabList"
                    :key="index"
                    @click="chooseTab(item.id)"
                >
                    {{ item.name }}
                </div>
            </div>
            <div class="tabBtn">
                <div class="tabBtnLi" @click="uploading">
                    <div class="tabBtnLiImg">
                        <img src="../assets/images/fs.png" alt="" />
                    </div>
                    <div class="tabBtnName">上传</div>
                    <input
                        type="file"
                        @change="handleFileChange"
                        ref="fileInput"
                        style="display: none"
                    />
                </div>
                <div class="tabBtnLi" @click="send">
                    <div class="tabBtnLiImg">
                        <img src="../assets/images/fs.png" alt="" />
                    </div>
                    <div class="tabBtnName">发送</div>
                </div>
                <div class="tabBtnLi" @click="shareLink">
                    <div class="tabBtnLiImg">
                        <img src="../assets/images/lj.png" alt="" />
                    </div>
                    <div class="tabBtnName">分享链接</div>
                </div>

                <div class="tabBtnLi" @click="shanchu">
                    <div class="tabBtnLiImg">
                        <img src="../assets/images/sc.png" alt="" />
                    </div>
                    <div class="tabBtnName">删除</div>
                </div>

                <div class="tabBtnLi" @click="clearChoose">
                    <div class="tabBtnLiImg">
                        <img src="../assets/images/qcxz.png" alt="" />
                    </div>
                    <div class="tabBtnName">清除选择</div>
                </div>
            </div>
        </div>

        <div v-if="isMobile" class="mobile-file-list">
            <div
                v-for="(item, index) in dataList"
                :key="index"
                class="file-card"
            >
                <div class="card-header">
                    <el-checkbox
                        v-model="item.checked"
                        @change="handleCheckChange(item)"
                    ></el-checkbox>
                    <div class="file-icon" @click="rowClicks(item.filePath)">
                        <i :class="getFileIcon(item.fileType)"></i>
                    </div>
                    <div class="file-info" @click="rowClicks(item.filePath)">
                        <div class="file-name">
                            {{ item.fileName }}
                        </div>
                        <div class="file-meta">
                            <span>{{ item.fileSize }}</span>
                            <span>{{ item.createTime }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-table
            class="tabaleBox"
            ref="multipleTable"
            :data="dataList"
            tooltip-effect="dark"
            style="width: 100%"
            height="100%"
            @row-click="rowClick"
            @selection-change="handleSelectionChange"
            v-else
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="文件名">
                <template slot-scope="scope">
                    {{ scope.row.fileName }}
                </template>
            </el-table-column>
            <el-table-column prop="fileSize" label="文件大小">
            </el-table-column>
            <el-table-column prop="fileType" label="类型" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="时间"
                show-overflow-tooltip
            >
            </el-table-column>
        </el-table>
        <el-dialog title="等待中" :visible.sync="dialogTableVisible">
            <div class="erwmBox">
                <div class="erwmNum">{{ dataMsg.shareCode }}</div>
                <div class="erwmImg">
                    <canvas ref="qrCanvas" style="background: #f5f5f5"></canvas>
                    <!-- <img src="../assets/images/logo.png" alt="" /> -->
                </div>
                <div class="erwmTip">请在另一个设备中输入6位数密钥</div>
                <div class="erwmTime" @click="dialogTime = true">
                    <div class="erwmTimeName">有效期</div>
                    <div class="erwmTimeKey">
                        {{ dataMsg.validityData
                        }}<i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="erwmBtn" @click="copyLink">分享链接</div>
            </div>
        </el-dialog>

        <el-dialog title="分享链接" :visible.sync="shareLinkShow">
            <div class="erwmBox">
                <div class="erwmNum">{{ dataMsg.shareCode }}</div>
                <div class="erwmTip">请在另一个设备中输入6位数密钥</div>
                <div class="erwmTime" @click="dialogTime = true">
                    <div class="erwmTimeName">有效期</div>
                    <div class="erwmTimeKey">
                        {{ dataMsg.validityData
                        }}<i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="erwmBtn" @click="copyLink">复制链接</div>
            </div>
        </el-dialog>

        <el-dialog
            title="有效期设置"
            :visible.sync="dialogTime"
            custom-class="timeCss"
        >
            <div class="validityBox">
                <div class="validity">
                    <div class="validityTit"><span>*</span>有效期</div>
                    <div class="validityDay">
                        <div
                            class="validityDayLi"
                            @click="timeChoose('10分钟')"
                        >
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '10分钟' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '10分钟'"
                                ></div>
                            </div>
                            <span>10</span>分钟
                        </div>
                        <div class="validityDayLi" @click="timeChoose('7天')">
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '7天' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '7天'"
                                ></div>
                            </div>
                            <span>7</span>天
                        </div>
                        <div class="validityDayLi" @click="timeChoose('14天')">
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '14天' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '14天'"
                                ></div>
                            </div>
                            <span>14</span>天
                        </div>
                        <div class="validityDayLi" @click="timeChoose('30天')">
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '30天' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '30天'"
                                ></div>
                            </div>
                            <span>30</span>天
                        </div>

                        <div
                            class="validityDayLi"
                            @click="timeChoose('永久有效')"
                        >
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '永久有效'
                                        ? 'validityDayQuanA'
                                        : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '永久有效'"
                                ></div>
                            </div>
                            <div>
                                <span>永久有效</span>
                                <div class="tip">
                                    在手动取消前，分享将持续有效
                                </div>
                            </div>
                        </div>
                        <div
                            class="validityDayLi"
                            @click="timeChoose('自定义')"
                        >
                            <div
                                class="validityDayQuan"
                                :class="
                                    subDay == '自定义' ? 'validityDayQuanA' : ''
                                "
                            >
                                <div
                                    class="validityDayQuandian"
                                    v-if="subDay == '自定义'"
                                ></div>
                            </div>
                            <el-date-picker
                                v-model="dayTime"
                                align="right"
                                type="date"
                                placeholder="选择日期"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                :editable="false"
                                v-if="subDay == '自定义'"
                            >
                            </el-date-picker>
                            <div v-if="subDay != '自定义'">
                                <span>自定义</span>到期日
                                <div class="tip">可以设定365天内任意有效期</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="validityBtn" @click="sureTime">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="上传中" :visible.sync="uploadFile">
            <div class="erwmBox">
                <div class="erwmNum" style="font-size: 15px">
                    {{ fileName }}
                </div>
                <!-- 分块：{{ dfk }}/{{ zfk }} -->
                <div class="erwmTip">
                    <el-progress :percentage="percent"></el-progress>
                </div>

                <!-- <div class="erwmBtn" @click="sureFile" style="margin-top: 30px">
                    确定
                </div> -->
            </div>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="deleteFlag" width="30%">
            <span>确定删除当前文件吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteFlag = false">取 消</el-button>
                <el-button type="primary" @click="deleteFile">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="wenjian" width="30%">
            <span>当前文件已大于10MB，请下载APP使用。</span>
            <p>
                下载地址<a href="http://96.9.231.213:8092/秒达.apk"
                    >http://96.9.231.213:8092/秒达.apk</a
                >
            </p>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="wenjian = false">取 消</el-button>
                <el-button type="primary" @click="goDown"
                    >去 下 载</el-button
                >
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import QRCode from 'qrcode'
// import { listFile, createShare } from '@/api/index'
import {
    listFile,
    createShare,
    setShareValidityData,
    checkChunk,
    uploadChunk,
    delFile
} from '@/api/index'

const chunkSize = 5 * 1024 * 1024 // 每个分片大小：5MB

let uploadedChunks = new Set() // 已上传的分片索引集合

export default {
    data() {
        return {
            zfk: 0,
            dfk: 0,
            wenjian: false,
            deleteFlag: false,
            percent: 0,
            percentAll: 0,
            uploadFile: false,
            dayTime: '',
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date(2025, 6, 10).getTime() // 2025-07-10（月份0-11）
                    const nextYear = today + 365 * 8.64e7 // 当前时间+365天（毫秒数）
                    return time.getTime() < today || time.getTime() > nextYear
                }
            },
            subDay: '10分钟',
            dialogTableVisible: false,
            dialogTime: false,
            tabList: [
                { name: '照片', id: 2 },
                { name: '视频', id: 3 },
                { name: '音频', id: 4 },
                { name: '文件', id: 5 },
                { name: '其他', id: 6 }
            ],
            tabIndex: 2,
            multipleSelection: [],
            dataList: [],
            dataMsg: {},
            selectedData: [],
            fileName: '',
            shareLinkShow: false
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768
        }
    },
    created() {
        this.getInit()
    },
    methods: {
        handleCheckChange(item) {
            const index = this.selectedData.findIndex(
                (selected) => selected.id === item.id
            )
            if (index > -1) {
                this.selectedData.splice(index, 1)
            } else {
                this.selectedData.push(item)
            }
        },
        // toggleSelect(item) {
        //     const index = this.selectedData.findIndex(
        //         (selected) => selected.id === item.id
        //     )
        //     if (index > -1) {
        //         this.selectedData.splice(index, 1)
        //     } else {
        //         this.selectedData.push(item)
        //     }
        // },
        getFileIcon(fileType) {
            const typeMap = {
                图片: 'el-icon-picture',
                视频: 'el-icon-video-camera',
                音频: 'el-icon-headset',
                文档: 'el-icon-document',
                压缩包: 'el-icon-files',
                其他: 'el-icon-question'
            }
            return typeMap[fileType] || typeMap['其他']
        },
        isSelected(item) {
            return this.selectedData.some((selected) => selected.id === item.id)
        },
        // 删除
        shanchu() {
            if (this.selectedData.length <= 0) {
                this.$message({
                    message: '请选择文件',
                    type: 'error'
                })
                return
            }
            this.deleteFlag = true
        },
        deleteFile() {
            console.log(this.selectedData)
            if (this.selectedData.length <= 0) {
                this.$message({
                    message: '请选择文件',
                    type: 'error'
                })
                return
            }
            let array = []
            for (var a = 0; a < this.selectedData.length; a++) {
                array.push(this.selectedData[a].id)
            }

            delFile({ id: array.join(',') }).then((res) => {
                this.deleteFlag = false
                if (res.code == 0) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    this.getInit()
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
        },
        sureFile() {
            this.uploadFile = false
            this.getInit()
        },
        // 文件分片
        createFileChunks(file) {
            const chunks = []
            let cur = 0
            while (cur < file.size) {
                const end = Math.min(cur + chunkSize, file.size)
                const chunk = file.slice(cur, end)
                chunks.push(chunk)
                cur = end
            }
            console.log(chunks, '分片数据')
            return chunks
        },
        // 计算整个文件的 MD5
        async computeFileMD5(chunks) {
            console.log(chunks, 'chunkschunkschunkschunks')
            return new Promise((resolve) => {
                const spark = new SparkMD5.ArrayBuffer()
                let offset = 0

                function loadNext() {
                    if (offset < chunks.length) {
                        const reader = new FileReader()
                        console.log(reader, 'readerreaderreaderreaderreader')
                        reader.onload = function (e) {
                            spark.append(e.target.result)
                            offset++
                            loadNext()
                        }
                        console.log(chunks[offset], '111111111111111')
                        reader.readAsArrayBuffer(chunks[offset])
                    } else {
                        resolve(spark.end())
                    }
                }

                loadNext()
            })
        },
        calculatePercentage(part, total) {
            return Math.floor((part / total) * 100)
        },
        checkChunkExists(fileMd5, chunkIndex) {
            return new Promise((resolve) => {
                checkChunk({
                    fileMd5: fileMd5,
                    chunkIndex: chunkIndex
                }).then((res) => {
                    resolve(res)
                })
            })
        },
        goDown() {},
        // 选择文件
        async handleFileChange(event) {
            try {
                const file = event.target.files[0]
                if (!file) return

                this.fileName = file.name
                this.uploadFile = true
                this.percent = 0

                // 1. 文件分片
                const chunks = this.createFileChunks(file)
                const totalChunks = chunks.length

                // 2. 计算文件MD5
                console.log('开始计算文件MD5...')
                const fileMd5 = await this.computeFileMD5(chunks)
                console.log('文件MD5计算完成:', fileMd5)

                // 3. 初始化已上传分片集合
                uploadedChunks = new Set()

                // 4. 上传进度跟踪
                let uploadedCount = 0
                const updateProgress = () => {
                    this.percent = Math.floor(
                        (uploadedCount / totalChunks) * 100
                    )
                }

                // 5. 并行上传控制（限制并发数）
                const MAX_CONCURRENT_UPLOADS = 3 // 最大并发上传数
                const uploadQueue = []

                for (
                    let chunkIndex = 0;
                    chunkIndex < totalChunks;
                    chunkIndex++
                ) {
                    // 检查分片是否已上传
                    const { exists, fileUrl } = await this.checkChunkExists(
                        fileMd5,
                        chunkIndex
                    )

                    if (exists) {
                        uploadedChunks.add(chunkIndex)
                        uploadedCount++
                        updateProgress()
                        console.log(
                            `分片 ${chunkIndex + 1}/${totalChunks} 已存在，跳过`
                        )
                        continue
                    }
                    console.log(123123)

                    if (fileUrl) {
                        // 如果已存在完整文件
                        this.percent = 100
                        this.sureFile()
                        this.$message.success('上传成功')
                        return
                    }

                    // 创建上传任务
                    const uploadTask = async () => {
                        try {
                            const formData = new FormData()
                            formData.append('file', chunks[chunkIndex])
                            formData.append('fileMd5', fileMd5)
                            formData.append('chunkIndex', chunkIndex)
                            formData.append('totalChunks', totalChunks)
                            formData.append('fileName', file.name)

                            const res = await uploadChunk(formData)
                            console.log(
                                `分片 ${
                                    chunkIndex + 1
                                }/${totalChunks} 上传成功`,
                                res
                            )

                            if (res.fileUrl) {
                                // 全部分片上传完成
                                this.percent = 100
                                this.sureFile()
                                this.$message.success('上传成功')
                                return
                            }

                            uploadedChunks.add(chunkIndex)
                            uploadedCount++
                            updateProgress()
                        } catch (err) {
                            console.error(
                                `分片 ${
                                    chunkIndex + 1
                                }/${totalChunks} 上传失败:`,
                                err
                            )
                            // 可以选择重试逻辑
                            throw err
                        }
                    }

                    // 添加到上传队列
                    uploadQueue.push(uploadTask())

                    // 控制并发数
                    if (uploadQueue.length >= MAX_CONCURRENT_UPLOADS) {
                        await Promise.race(uploadQueue)
                    }
                }

                // 等待所有上传完成
                await Promise.all(uploadQueue)
            } catch (err) {
                console.error('文件上传失败:', err)
                this.$message.error('文件上传失败: ' + err.message)
                this.uploadFile = false
            } finally {
                // 重置文件输入，允许重复上传同一文件
                event.target.value = ''
            }
        },
        // async handleFileChange(event) {
        //     try {
        //         console.log(event, '选择的文件')
        //         this.fileName = event.target.files[0].name

        //         let file = event.target.files[0]
        //         if (!file) {
        //             return
        //         }
        //         console.log(file, 'filefilefile')
        //         const chunks = this.createFileChunks(file)
        //         console.log(chunks, 'chunkschunkschunkschunks')
        //         const fileMd5 = await this.computeFileMD5(chunks)
        //         console.log(fileMd5)
        //         const totalChunks = chunks.length
        //         this.uploadFile = true
        //         for (var a = 0; a <= totalChunks; a++) {
        //             this.percent = this.calculatePercentage(a, totalChunks)
        //             console.log(this.percent, '进度')
        //             console.log(1, this.currentChunkIndex)
        //             this.currentChunkIndex = a
        //             console.log(2)
        //             if (uploadedChunks.has(a)) continue
        //             const chunk = chunks[a]
        //             console.log(3)
        //             // 检查是否已上传
        //             const existsObj = await this.checkChunkExists(fileMd5, a)
        //             console.log(existsObj)
        //             if (existsObj.exists) {
        //                 console.log(4)
        //                 uploadedChunks.add(a)
        //                 console.log(`分片 ${a}/${totalChunks - 1} 已存在，跳过`)
        //                 continue
        //             }
        //             if (existsObj.fileUrl) {
        //                 this.percent = 100
        //                 this.sureFile()
        //                 this.$message({
        //                     message: '上传成功',
        //                     type: 'success'
        //                 })
        //                 return
        //             }
        //             // console.log(5)
        //             // console.log(`正在上传分片 ${a}/${totalChunks - 1}`)
        //             // console.log(chunk, '12312312312312312')

        //             const formData = new FormData()
        //             formData.append('file', chunk)
        //             formData.append('fileMd5', fileMd5)
        //             formData.append('chunkIndex', a)
        //             formData.append('totalChunks', totalChunks)
        //             formData.append('fileName', file.name)

        //             console.log(formData, 'formDataformData')
        //             uploadChunk(formData).then((res) => {
        //                 console.log(res, 'kladsfhkjasfkjasfkj')

        //                 // if (res.fileUrl) {
        //                 //     this.percent = 100
        //                 //     this.sureFile()
        //                 //     this.$message({
        //                 //         message: '上传成功',
        //                 //         type: 'success'
        //                 //     })
        //                 // }
        //             })
        //         }
        //     } catch (err) {
        //         console.log(`❌ 分片 ${a} 上传失败: ${err.message}`)
        //     }
        // },
        clearChoose() {
            this.$refs.multipleTable.clearSelection()
        },
        // 上传
        uploading() {
            this.$refs['fileInput'].click()
        },
        // 确认选择的时间
        sureTime() {
            if (this.subDay == '自定义') {
                if (!this.dayTime) {
                    this.$message({
                        message: '请选择到期日期',
                        type: 'error'
                    })
                    return
                }
            }
            console.log(this.dayTime)
            setShareValidityData({
                shareId: this.dataMsg.id,
                validityData:
                    this.subDay == '自定义' ? this.dayTime : this.subDay
            }).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: '设置成功',
                        type: 'success'
                    })
                    this.dataMsg = res.data
                    this.dialogTime = false
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
        },
        // 选择有效期时间
        timeChoose(name) {
            // if ((name = '自定义')) {
            // }
            this.subDay = name
        },
        // 选择发送的文件
        handleSelectionChange(val) {
            this.selectedData = val
        },

        // 切换类型获取列表
        chooseTab(id) {
            this.selectedData = []
            this.tabIndex = id
            this.getInit()
        },
        // 某一行点击
        rowClick(event) {
            window.open(event.filePath, '_blank')
        },
        rowClicks(urlSrc) {
            window.open(urlSrc, '_blank')
        },
        async copyText(text) {
            try {
                await navigator.clipboard.writeText(text)
                this.$message.success(' 复制成功')
            } catch (err) {
                console.error(' 复制失败:', err)
                this.fallbackCopy(text) // 降级方案
            }
        },
        fallbackCopy(text) {
            const textarea = document.createElement('textarea')
            textarea.value = text
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
            this.$message.success(' 复制成功')
        },
        // 分享链接
        shareLink() {
            if (this.selectedData.length <= 0) {
                this.$message({
                    message: '请选择文件',
                    type: 'error'
                })
                return
            }
            let array = []
            for (var a = 0; a < this.selectedData.length; a++) {
                array.push(this.selectedData[a].id)
            }
            createShare({ ids: array.join(',') }).then((res) => {
                if (res.code == 0) {
                    this.dataMsg = res.data
                    this.shareLinkShow = true
                    // this.copyText(res.data.shareCode)
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
        },
        copyLink() {
            this.copyText(
                'http://96.9.231.213:8092/#/transferPage?code=' +
                    this.dataMsg.shareCode
            )
            console.log(process.env.VUE_APP_BASE_API)
            this.shareLinkShow = false

            // http://8.134.94.20:8092/#/transferPage?code=123345
        },
        // 发送
        send() {
            console.log(this.selectedData)
            if (this.selectedData.length <= 0) {
                this.$message({
                    message: '请选择文件',
                    type: 'error'
                })
                return
            }
            let array = []
            for (var a = 0; a < this.selectedData.length; a++) {
                array.push(this.selectedData[a].id)
            }
            createShare({ ids: array.join(',') }).then((res) => {
                if (res.code == 0) {
                    this.dataMsg = res.data
                    this.dialogTableVisible = true
                    this.$nextTick(() => {
                        QRCode.toCanvas(
                            this.$refs.qrCanvas,
                            res.data.shareCode,
                            {
                                width: 180,
                                margin: 2,
                                color: {
                                    dark: '#000000', // 确保颜色值有效
                                    light: '#ffffff'
                                }
                            },
                            (error) => {
                                if (error) console.error(error)
                            }
                        )
                    })

                    // setTimeout(()=>{
                    // 	this.creatQrcode()
                    // },2000)
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })

            // this.dialogTableVisible = true
        },
        getInit() {
            let name = ''
            if (this.tabIndex == 2) {
                name = '图片'
            } else if (this.tabIndex == 3) {
                name = '视频'
            } else if (this.tabIndex == 4) {
                name = '音频'
            } else if (this.tabIndex == 5) {
                name = '文件'
            } else if (this.tabIndex == 6) {
                name = '其他'
            }
            listFile({
                fileType: name
            }).then((res) => {
                if (res.code == 0) {
                    for (var a = 0; a < res.data.length; a++) {
                        res.data[a].checked = false
                    }
                    this.dataList = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 25px;
    box-sizing: border-box;
    display: flex;
    height: calc(100vh - 100px);
    flex-direction: column;
    width: 100%;
}
.tabaleBox {
    flex: 1;
    overflow: auto;
}
.tabBig {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabBtn {
        display: flex;
        align-items: center;
        .tabBtnLi {
            margin-left: 30px;
            text-align: center;
            .tabBtnLiImg {
                width: 42px;
                height: 42px;
                border-radius: 8px;
                background: rgba(1, 149, 255, 0.1);
                display: flex;
                align-items: center;
                justify-content: center;

                margin: 0 auto;
                img {
                    width: 18px;
                    height: 18px;
                }
            }

            .tabBtnName {
                color: rgb(1, 149, 255);
                font-size: 12px;
                font-weight: 400;
                font-family: 'HarmonyOSSansSC';
                margin-top: 10px;
            }
        }
    }
}
.tabBox {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ecedfc;
    padding-bottom: 25px;

    .tabLi {
        color: #a3aab3;
        font-size: 16px;
        font-weight: 400;
        font-family: 'HarmonyOSSansSC';
        margin-right: 24px;
        width: 72px;
        text-align: center;
    }
    .tabLiA {
        width: 72px;
        height: 30px;
        border-radius: 60px;
        background: #0195ff;
        display: flex;

        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        font-family: 'HarmonyOSSansSC';
    }
}
.erwmBox {
    text-align: center;
    .erwmNum {
        color: #000000;
        font-size: 60px;
        font-weight: 700;
        font-family: 'HarmonyOSSansSC';
    }

    .erwmImg {
        width: 238px;
        height: 238px;
        margin: 0 auto;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .erwmTip {
        color: #9a9a9a;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        font-family: 'HarmonyOSSansSC';
    }
    .erwmTime {
        width: 438px;
        height: 64px;
        border-radius: 16px;
        background: #ffffff;
        box-shadow: 0 2px 10px 0 #0000001a;
        margin: 22px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 0 20px;

        box-sizing: border-box;
        .erwmTimeName {
            color: #000000;
            font-size: 16px;
            font-weight: 500;
            font-family: 'HarmonyOSSansSC';
        }

        .erwmTimeKey {
            color: #0195ff;
            font-size: 16px;
            font-weight: 500;
            font-family: 'HarmonyOSSansSC';
        }
    }
    .erwmBtn {
        width: 256px;
        height: 64px;
        border-radius: 60px;
        background: #0195ff;
        box-shadow: 0 2px 30px 0 #0195ff4d;
        margin: 0 auto;
        color: #ffffff;
        font-size: 24px;
        font-weight: 500;
        font-family: 'HarmonyOSSansSC';
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
::v-deep .el-dialog {
    border-radius: 15px !important;
}
.timeCss {
    z-index: 99999999 !important;
}

.validityBox {
    .validity {
        display: flex;
        .validityTit {
            color: #1d1d1d;
            font-size: 14px;
            font-weight: 400;
            font-family: 'HarmonyOSSansSC';
            span {
                color: #f0153f;
            }
        }
        .validityDay {
            margin-left: 20px;
            .validityDayLi {
                display: flex;
                align-items: center;
                color: #000000;
                font-size: 14px;
                font-weight: 500;
                font-family: 'HarmonyOSSansSC';

                margin-bottom: 24px;
                .validityDayQuan {
                    width: 24px;
                    height: 24px;
                    border-radius: 60px;
                    border: 1px solid #d4d6d9;
                    background: #ffffff;
                    margin-right: 10px;

                    display: flex;

                    align-items: center;
                    justify-content: center;
                    .validityDayQuandian {
                        width: 14px;
                        height: 14px;
                        background: #ffffff;
                        border-radius: 50%;
                    }
                }
                .validityDayQuanA {
                    background: #0195ff;
                }
                .tip {
                    color: #9a9a9a;
                    font-size: 14px;
                    font-weight: 400;
                    font-family: 'HarmonyOSSansSC';
                }
                span {
                    color: #0195ff;
                    margin-right: 5px;
                }
            }
        }
    }
    .validityBtn {
        width: 340px;
        height: 52px;
        border-radius: 60px;
        background: #0195ff;
        box-shadow: 0 2px 30px 0 #0195ff4d;
        margin: 0 auto;
        color: #ffffff;
        font-size: 24px;
        font-weight: 500;
        font-family: 'HarmonyOSSansSC';
        display: flex;

        align-items: center;
        justify-content: center;
    }
}

/* 移动端卡片式布局 */
.mobile-file-list {
    padding: 10px;
    overflow-y: auto;
    flex: 1;
}

.file-card {
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #eee;

    &.selected {
        border-color: #0195ff;
        background-color: rgba(1, 149, 255, 0.05);
    }

    .card-header {
        display: flex;
        align-items: center;

        .el-checkbox {
            margin-right: 12px;
        }

        .file-icon {
            margin-right: 12px;
            font-size: 24px;
            color: #0195ff;
        }

        .file-info {
            flex: 1;
            overflow: hidden;

            .file-name {
                font-size: 14px;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .file-meta {
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                color: #999;
                margin-top: 4px;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .content {
        padding: 15px;
        height: calc(100vh - 130px);
        box-sizing: border-box;
    }

    .tabBig {
        flex-direction: column;
        align-items: flex-start;

        .tabBox {
            padding-bottom: 15px;
            width: 100%;
            overflow-x: auto;
            white-space: nowrap;

            .tabLi {
                margin-right: 15px;
                width: 60px;
                font-size: 14px;

                &.tabLiA {
                    width: 60px;
                    height: 28px;
                    font-size: 14px;
                }
            }
        }

        .tabBtn {
            margin-top: 15px;
            width: 100%;
            justify-content: space-between;

            .tabBtnLi {
                margin-left: 0;
                width: 20%;

                .tabBtnLiImg {
                    width: 36px;
                    height: 36px;

                    img {
                        width: 16px;
                        height: 16px;
                    }
                }

                .tabBtnName {
                    font-size: 11px;
                    margin-top: 5px;
                }
            }
        }
    }

    .tabaleBox {
        ::v-deep .el-table {
            th,
            td {
                padding: 8px 0;
            }

            .el-table-column--selection {
                .cell {
                    padding-left: 10px !important;
                }
            }
        }
    }

    .erwmBox {
        padding: 0 10px;

        .erwmNum {
            font-size: 32px;
        }

        .erwmImg {
            width: 180px;
            height: 180px;
        }

        .erwmTime {
            width: 100%;
            height: 50px;
            margin: 15px auto;
            padding: 0 15px;
        }

        .erwmBtn {
            width: 80%;
            height: 50px;
            font-size: 18px;
        }
    }

    .validityBox {
        .validity {
            flex-direction: column;

            .validityDay {
                margin-left: 0;
                margin-top: 15px;

                .validityDayLi {
                    margin-bottom: 15px;

                    .el-date-picker {
                        width: 100%;
                    }
                }
            }
        }

        .validityBtn {
            width: 100%;
            height: 45px;
            font-size: 18px;
        }
    }

    /* 对话框调整 */
    ::v-deep .el-dialog {
        width: 90% !important;

        &__header {
            padding: 15px 20px;
        }

        &__body {
            padding: 20px;
        }
    }
    /* 隐藏PC表格 */
    .tabaleBox {
        display: none;
    }

    /* 显示移动端卡片 */
    .mobile-file-list {
        display: block;
    }

    /* 调整其他移动端样式 */
    .content {
        padding: 10px;
    }
}
</style>